import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Guid } from "guid-typescript";
import { Observable } from "rxjs";
import { ImportPayload } from "src/app/_models/Import/ImportModel";
import { AppConstants } from "src/app/constants/constants";
import { APP_CONFIG } from "src/app/lib/angular/injection-tokens";
import { IAppConfig } from "src/app/lib/config/app-config";

@Injectable({
  providedIn: "root"
})
export class ImportBatchDisableDeleteService {
  private baseUrl: string = this.config.protectedResourceEndpoint;
  private publicBaseUrl: string = this.config.publicBaseUrl;
  private static readonly IMPORT_PATH: string = "ImportBatchDisableDelete";
  private static readonly SSE_PATH: string = "PublicSSE/";
  private static readonly IMPORT_STATUS: string = "learnerbatchdisabledelete/status?subjectId=";
  private static readonly IMPORT_DL_ERROR_LIST: string = "errorlist";
  private static readonly IMPORT_CLEAR_SESSION: string = "clear-import";
  private static readonly IMPORT_HAS_IMPORTS: string = "has-import";
  private static readonly IMPORT_AUTH: string = "authorize";
  private static readonly IMPORT_CANCEL: string = "cancel";

  constructor(
    @Inject(APP_CONFIG) private config: IAppConfig,
    private http: HttpClient
  ) {}

  public uploadCSVFile$(payload: ImportPayload): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}${ImportBatchDisableDeleteService.IMPORT_PATH}`,
      payload.file
    );
  }

  public hasImport$(): Observable<number> {
    return this.http.get<number>(`
      ${this.baseUrl}${ImportBatchDisableDeleteService.IMPORT_PATH}${AppConstants.SLASH}${ImportBatchDisableDeleteService.IMPORT_HAS_IMPORTS}`
    );
  }

  public authorizeSSERequest$(): Observable<boolean> {
    return this.http.post<boolean>(`
      ${this.baseUrl}${ImportBatchDisableDeleteService.IMPORT_PATH}${AppConstants.SLASH}${ImportBatchDisableDeleteService.IMPORT_AUTH}`, {});
  }

  public downloadErrorList$(): Observable<string[]> {
    return this.http.get<string[]>(`
      ${this.baseUrl}${ImportBatchDisableDeleteService.IMPORT_PATH}${AppConstants.SLASH}${ImportBatchDisableDeleteService.IMPORT_DL_ERROR_LIST}`);
  }

  public getStatusStream(subjectId: Guid): EventSource {
    return new EventSource(`
      ${this.publicBaseUrl}${ImportBatchDisableDeleteService.SSE_PATH}${ImportBatchDisableDeleteService.IMPORT_STATUS}${subjectId}`);
  }

  public clearImportSession$(): Observable<boolean> {
    return this.http.get<boolean>(`
      ${this.baseUrl}${ImportBatchDisableDeleteService.IMPORT_PATH}${AppConstants.SLASH}${ImportBatchDisableDeleteService.IMPORT_CLEAR_SESSION}`);
  }

  public cancelImport$(): Observable<boolean> {
    return this.http.post<boolean>(`
      ${this.baseUrl}${ImportBatchDisableDeleteService.IMPORT_PATH}${AppConstants.SLASH}${ImportBatchDisableDeleteService.IMPORT_CANCEL}`, {});
  }
}